export const HANDOVER_POLL_MS = 60_000

export const CURRENT_SHIFT_QUERY_KEY = 'current-shift' as const
export const PENDING_HANDOFFS_QUERY_KEY = 'pending-handoffs' as const
export const SHIFT_HANDOFFS_QUERY_KEY = 'shift-handoffs' as const
export const ELIGIBLE_MANAGERS_QUERY_KEY = 'eligible-managers' as const
export const PREVIOUS_SHIFTS_QUERY_KEY = 'previous-shifts' as const
export const SHIFT_DETAIL_QUERY_KEY = 'shift-detail' as const

export const NOTES_MAX = 2000
